module.exports = __webpack_public_path__ + "static/media/archive-view-more.828e92d5.svg";